
Vue.component('driver-detail', require('./DriverDetail/vue/driver-detail').default);
Vue.component('driver-debug', require('./Driver/Tests/vue/driver-debug').default);

Vue.component('driver-upload', require('./DriverUpload/vue/driver-upload').default);
Vue.component('driver-upload-dialog', require('./DriverUpload/vue/driver-upload-dialog').default);
Vue.component('driver-upload-file', require('./DriverUpload/vue/driver-upload-file').default);